import { graphql } from 'gatsby';
import { Button, Text, TextColor, TextVariant, TextWeight } from 'hem-ui';
import kebabCase from 'lodash/kebabCase';
import React from 'react';

import { ImageRow } from '../ImageRow';
import {
  address,
  appointment,
  contactInformation,
  images,
  openingHours,
  root,
  titleDescription,
} from './Office.module.scss';

export const Office: React.FC<Queries.OfficeFragment> = (
  office,
): JSX.Element => {
  return (
    <div className={root} id={`${kebabCase(office.title)}`}>
      <div className={images}>
        <ImageRow images={office.images} />
      </div>
      <div className={titleDescription}>
        <Text tag="h2" variant={TextVariant.HEADLINE_SMALL}>
          {office.title}
        </Text>

        <Text
          tag="p"
          variant={TextVariant.BODY_SMALL}
          dangerouslySetInnerHTML={{
            __html: office.desc?.childMarkdownRemark.html,
          }}
        />
      </div>
      <div className={contactInformation}>
        {office.address?.address ? (
          <Text
            tag="a"
            className={address}
            href={`https://maps.google.com/?q=${office.address?.address
              .split('\n')
              .join(' ')}`}
            target="_blank"
            variant={TextVariant.BODY_SMALL}
            style={{ display: 'block' }}
            dangerouslySetInnerHTML={{
              __html: office.address?.address.split('\n').join('<br />'),
            }}
          />
        ) : null}

        {(!!office.openingHours || !!office.openingDays) && (
          <Text
            tag="p"
            className={openingHours}
            variant={TextVariant.BODY_SMALL}
          >
            <Text
              weight={TextWeight.BOLD}
              variant={TextVariant.BODY_SMALL}
              style={{ marginRight: '1rem' }}
            >
              {office.openingDays}
            </Text>{' '}
            {office.openingHours}
          </Text>
        )}

        {!!office.phoneNumber && (
          <Text
            tag="a"
            href={`tel:${office.phoneNumber
              .replace(/ /gi, '')
              .replace(/\+/gi, '00')
              .replace(/\(/gi, '')
              .replace(/\)/gi, '')}`}
            variant={TextVariant.BODY_SMALL}
            style={{ display: 'block' }}
          >
            {office.phoneNumber}
          </Text>
        )}

        <Text
          tag="a"
          href={`mailto:${office.emailAddress}`}
          variant={TextVariant.BODY_SMALL}
          style={{ display: 'block' }}
        >
          {office.emailAddress}
        </Text>

        {office.scheduleAVisitUrl ? (
          <div className={appointment}>
            <Button
              // @ts-expect-error need to type link attrs to button as it can turn into a <a> tag :s
              target="_blank"
              rel="noopener noreferrer"
              to={office.scheduleAVisitUrl}
            >
              Schedule a visit
            </Button>
            <Text
              tag="small"
              variant={TextVariant.BODY_SMALL}
              color={TextColor.GRAY_DARK}
            >
              By appointment only
            </Text>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Office;

export const query = graphql`
  fragment Office on ContentfulOffice {
    __typename
    contentful_id
    title
    scheduleAVisitUrl
    phoneNumber
    openingDays
    openingHours
    emailAddress
    desc: description {
      childMarkdownRemark {
        html
      }
    }
    address {
      address
    }
    images {
      gatsbyImageData(formats: [AUTO, AVIF, WEBP], quality: 80, width: 1280)
      description
      title
    }
  }
`;
